import React, { useEffect, useRef, useState } from "react";
import { Survey } from "survey-react-ui";
import { Model } from "survey-core";
import "survey-core/defaultV2.min.css";
import "./../../styles/CustomSurvey.css"; // Importamos nuestro CSS personalizado
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const Popup = ({ form, onClose, onComplete, textButton, visibleQuestions, savedAnswers }) => {
  const [isCompleteButtonEnabled, setIsCompleteButtonEnabled] = useState(false);
  const isCompleteCalled = useRef(false); // Si se ha llamado a onComplete o no, porque sino se ejecuta mas de una vez

  // Convertir visibleQuestions a un array de nombres de preguntas
  const visibleQuestionNames = visibleQuestions ? visibleQuestions.split('|') : [];

  // Filtrar las preguntas visibles
  const filteredForm = {
    ...form,
    pages: form.pages.map(page => ({
      ...page,
      elements: page.elements.filter(question => visibleQuestionNames.includes(question.name))
    }))
  };

  // Instancia única del modelo de encuesta
  const survey = useRef(new Model(visibleQuestions ? filteredForm : form)).current;

  // Pre-fill the survey with saved answers
  useEffect(() => {
    if (savedAnswers) {
      survey.data = savedAnswers;
    } else {
      survey.data = {}; // Evitar que tenga valores null
    }
  }, [savedAnswers, survey]);
  // Personalización de textos
  survey.completeText = "Enviar";

  // Quitar el estilo rojo y agregar estilo personalizado
  survey.onAfterRenderQuestion.add((sender, options) => {
    if (options.question.isRequired) {
      options.htmlElement.classList.remove("sv-question--error"); // Quita el estilo rojo
      options.htmlElement.classList.add("custom-required"); // Agrega estilo personalizado
    }
  });

  // Personalizar los mensajes de error
  survey.onValidateQuestion.add((sender, options) => {
    if (options.question.isRequired && !options.value) {
      options.error = "Este campo es obligatorio."; // Mensaje personalizado
    }
  });

  // Validación para habilitar el botón "Enviar"
  useEffect(() => {
    const checkRequiredFields = () => {
      setIsCompleteButtonEnabled(!survey.isCurrentPageHasErrors);
    };

    survey.onValueChanged.add(checkRequiredFields);
    survey.onCurrentPageChanged.add(checkRequiredFields);
    checkRequiredFields();

    return () => {
      survey.onValueChanged.remove(checkRequiredFields);
      survey.onCurrentPageChanged.remove(checkRequiredFields);
    };
  }, [survey]);

  // Callback cuando se completa la encuesta
  survey.onComplete.add((sender) => {
    if (!isCompleteCalled.current) {
      isCompleteCalled.current = true; // Set the flag to true
      const surveyData = sender.data;
      onComplete(surveyData);
      onClose();
    }
  });

  return (
    <div className="popup">
      <div className="popup-inner">
        <button className="close-btn" onClick={onClose}>
        <FontAwesomeIcon icon={faTimes} />
        </button>
        <Survey model={survey} showNavigationButtons={false} />
        <div style={{ textAlign: "right" }}>
          <button
            onClick={() => survey.completeLastPage()}
            disabled={!isCompleteButtonEnabled}
            style={{
              marginRight: "10px",
              padding: "20px",
              fontSize: "15px",
              fontSeight: "600",
              backgroundColor: isCompleteButtonEnabled ? "#28a745" : "#ccc",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: isCompleteButtonEnabled ? "pointer" : "not-allowed",
            }}
          >
            {textButton ? textButton : "Enviar"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
